module.exports = __webpack_public_path__ + "img/stealth-mode-bg-lower.91c74219.png";